module.exports = __webpack_public_path__ + "img/avatar1.fa2e16d3.png";